import { useState, Fragment } from 'react'
import { isMobile, isTablet, BrowserView, MobileView } from 'react-device-detect';
import parse from 'html-react-parser';

const PageHeader = ({ data }) => {
    // console.log('data in PageHeader', data)

    const [activeTab, setActiveTab] = useState(0)

    // const headerVideoSrc = data.headerVideoSrc ? data.headerVideoSrc : null
    // const headerImageSrc = data.headerImageSrc ? data.headerImageSrc : null
    // const headerImageSrcMobile = data.headerImageSrcMobile ? data.headerImageSrcMobile : null
    // const headerImageAlt = data.headerImageAlt ? data.headerImageAlt : 'header image'

    return (
        <div className={`page-header-outer ${isTablet ? 'tablet-header' : ''}`}>
            <div className="page-header-inner">
                <div className="page-header-content">
                    <h1 className="page-title">{parse(data.pageTitle)}</h1>
                    <div className="header-description page-description">
                        {parse(data.headerDesc)}
                    </div>
                    <div className="header-ctas">
                        <ul className="nostyle ctas-list">
                            {data.headerCTAs.map((c, i) => {
                                return (
                                    <li
                                        key={c.id}
                                        className={`header-cta ${
                                            i === activeTab
                                                ? 'active-tab'
                                                : null
                                        }`}
                                    >
                                        <a
                                            className="header-cta-link large-button cta-button"
                                            href={c.headerCTALink}
                                            onClick={() => setActiveTab(i)}
                                        >
                                            {c.headerCTA}
                                        </a>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PageHeader
